import { Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";
import ReactJson from "react-json-view";

// JSON'u katlanabilir/renkli bir ağaç olarak gösterir (düz <pre> yerine).
// Ayrıştırılamayan içerik (düz metin, bozuk JSON) olduğu gibi metin olarak gösterilir,
// böylece log kaydı hiçbir durumda "boş" görünmez.
export default function JsonViewModal({ visible, data, onClose, title, description })
{
    const { t } = useTranslation();

    const parse = (raw) => {
        if (raw === null || raw === undefined || raw === '')
            return { tree: null, text: '' };

        if (typeof raw !== 'string')
            return typeof raw === 'object' ? { tree: raw, text: '' } : { tree: null, text: String(raw) };

        try {
            const parsed = JSON.parse(raw);
            return typeof parsed === 'object' && parsed !== null
                ? { tree: parsed, text: '' }
                : { tree: null, text: String(parsed) };
        } catch (e) {
            return { tree: null, text: raw };
        }
    };

    const { tree, text } = parse(data);
    const hasContent = tree !== null || !!text;

    return (
        <Modal
            title={title || t('JSON Data')}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            {description && (
                <div style={{
                    marginBottom: 12,
                    padding: '8px 12px',
                    background: '#fafafa',
                    border: '1px solid #f0f0f0',
                    borderRadius: 4
                }}>
                    <Typography.Text type={'secondary'} style={{ fontSize: 11 }}>
                        {t('Description')}
                    </Typography.Text>
                    <div style={{ fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {description}
                    </div>
                </div>
            )}

            {hasContent && (
                <div style={{
                    maxHeight: '60vh',
                    overflow: 'auto',
                    background: '#fafafa',
                    border: '1px solid #f0f0f0',
                    borderRadius: 4,
                    padding: 12
                }}>
                    {tree
                        ? (
                            <ReactJson
                                src={tree}
                                name={false}
                                // İlk iki seviye açık; daha derini katlı gelir (uzun log'lar taşmasın).
                                collapsed={2}
                                displayDataTypes={false}
                                displayObjectSize={false}
                                enableClipboard={true}
                                indentWidth={2}
                                style={{ fontSize: 12, background: 'transparent' }}
                            />
                        )
                        : (
                            <pre style={{
                                margin: 0,
                                fontSize: 12,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word'
                            }}>
                                {text}
                            </pre>
                        )}
                </div>
            )}
        </Modal>
    )
}
